<!-- A refresh button commonly used in heatmap overlays -->
<template>
  <transition name="slide-y-transition">
    <v-btn
      v-if="show"
      :disabled="disabled"
      small
      round
      color="blue darken-2"
      class="white--text refresh-button"
      @click="() => {this.$emit('click')}"
      style="text-transform: none;"
    >Refresh Data</v-btn>
  </transition>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      fire () {
        this.$emit('click')
      }
    }
  }
</script>

<style lang="stylus">
  .refresh-button
    border-radius: 5px;
</style>



// WEBPACK FOOTER //
// frontend/src/components/heatmap/RefreshButton.vue